import React, { useEffect } from "react";
import { CalenderIcon, IconDelete } from "../Icon";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";
import {
  FixedAssetPurchase,
  FixedAssetRegisterForm,
} from "../../commonTypes/fixedAssetRegisterTypes";

import { Button } from "react-bootstrap";
import moment from "moment";
import { handleDate, reverseDate } from "../../utils/commonFunctions";
type AppProps = {
  fixedAssetRegisterForm: FixedAssetRegisterForm;
  setFixedAssetRegisterForm: React.Dispatch<React.SetStateAction<any>>;
  handleInputDetailsChange: (data: any) => void;
  handleDeleteAccount: (data: any) => void;
  totalPurchaseDetails: FixedAssetPurchase[];
  setTotalPurchaseDetails: any;
};
const PurchaseDetails = ({
  setFixedAssetRegisterForm,
  setTotalPurchaseDetails,
  totalPurchaseDetails,
  handleDeleteAccount,
}: AppProps) => {
  useEffect(() => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        purchase_details: [...totalPurchaseDetails],
      };
    });
  }, [totalPurchaseDetails]);

  const handleAddMore = () => {
    setTotalPurchaseDetails((prv: FixedAssetPurchase[]) => [
      ...prv,

      {
        // fixed_asset_id: "",
        item_name: "",
        supplier_name: "",
        invoice_number: "",
        invoice_date: null,
        amount: null,
      },
    ]);
  };

  const allAccountData = (index: number, e: any) => {
    let temp: any = JSON.parse(JSON.stringify(totalPurchaseDetails));
    let temp1 = temp[index];
    temp1[e.target.name] = e?.target?.value;
    if (e.target.name === "amount" && !e?.target?.value) {
      temp1[e.target.name] = null;
    }
    setTotalPurchaseDetails((prv: FixedAssetPurchase[]) => [...temp]);
  };
  const handleInputChange = (e: any, index: number) => {
    let datePut = handleDate(moment(e).format("YYYY-MM-DD"));

    let temp: any = JSON.parse(JSON.stringify(totalPurchaseDetails));
    let temp1 = temp[index];
    temp1.invoice_date = datePut?.length ? reverseDate(datePut) : null;
    setTotalPurchaseDetails((prv: FixedAssetPurchase[]) => [...temp]);
  };
  return (
    <>
      {totalPurchaseDetails?.length === 1 ? <h6>PURCHASE DETAILS</h6> : ""}

      {totalPurchaseDetails?.length > 0 &&
        totalPurchaseDetails?.map((el, index) => {
          return (
            <>
              {totalPurchaseDetails?.length > 1 && (
                <h6 className="mt-4" style={{ color: "#6e7491" }}>
                  PURCHASE DETAILS{" "}
                  {index + 1 < 10 ? `0${index + 1}` : index + 1}
                </h6>
              )}
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="clientName">Item Name</label>
                    <div>
                      <input
                        name="item_name"
                        type="text"
                        className={`form-control`}
                        value={
                          totalPurchaseDetails &&
                          totalPurchaseDetails[index] &&
                          totalPurchaseDetails[index]?.["item_name"]
                        }
                        // onChange={(e) => handleInputDetailsChange(e)}
                        onChange={(e: any) => allAccountData(index, e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="clientName">Supplier Name</label>
                    <div>
                      <input
                        name="supplier_name"
                        type="text"
                        className={`form-control`}
                        // value={inputDetails?.title}
                        value={
                          totalPurchaseDetails &&
                          totalPurchaseDetails[index] &&
                          totalPurchaseDetails[index]?.["supplier_name"]
                        }
                        // onChange={(e) => handleInputDetailsChange(e)}
                        onChange={(e: any) => allAccountData(index, e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="clientName">Invoice Number</label>
                    <div>
                      <input
                        name="invoice_number"
                        type="text"
                        className={`form-control`}
                        // value={inputDetails?.title}
                        value={
                          totalPurchaseDetails &&
                          totalPurchaseDetails[index] &&
                          totalPurchaseDetails[index]["invoice_number"]
                            ? totalPurchaseDetails[index]["invoice_number"]
                            : ""
                        }
                        // onChange={(e) => handleInputDetailsChange(e)}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          allAccountData(index, e)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="clientName">Invoice Date</label>
                    <div>
                      <div>
                        <div className="d-flex flex-row position-relative">
                          <div className="date-picker-wraper mr-0 w-100">
                            <Label className="mr-0 w-100">
                              <DatePicker
                                dateFormat="dd-MM-yyyy"
                                selected={
                                  totalPurchaseDetails[index]?.["invoice_date"]
                                    ? new Date(
                                        moment(
                                          `${totalPurchaseDetails[index]?.["invoice_date"]}T00:00:00`,
                                          "DD-MM-YYYY"
                                        ).format("YYYY-MM-DD[T]HH:mm:ss")
                                      )
                                    : null
                                }
                                onChange={(e: any) => {
                                  handleInputChange(e, index);
                                }}
                                fixedHeight
                                showMonthDropdown
                                showYearDropdown
                                //   disabled={!isEdit}
                                name="invoice_date"
                                placeholderText="Select"
                                className="form-control"
                              />
                              <span
                                className="calender-icon"
                                style={{
                                  right: "20px",
                                  top: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <CalenderIcon />
                              </span>
                            </Label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="clientName">Amount</label>
                    <div>
                      <input
                        name="amount"
                        type="number"
                        className={`form-control`}
                        // value={inputDetails?.title}
                        value={
                          totalPurchaseDetails && totalPurchaseDetails[index]
                            ? totalPurchaseDetails[index]?.["amount"]
                            : ""
                        }
                        onWheel={(event) => event.currentTarget.blur()}
                        onChange={(e: any) => allAccountData(index, e)}
                      />
                    </div>
                  </div>
                </div>
                {totalPurchaseDetails?.length > 1 && (
                  <div
                    className="pointer"
                    style={{
                      display: "flex",
                      marginTop: "25px",
                      padding: "0px 10px",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "4px",
                      height: "37px",
                      border: "solid 1px #bfcbe1",
                    }}
                    onClick={() => handleDeleteAccount(index)}
                  >
                    <IconDelete />
                  </div>
                )}
              </div>
            </>
          );
        })}
      <div className="row mt-3 mb-3">
        <div className="col-3">
          <Button onClick={handleAddMore}>+ Add More Row</Button>
        </div>
      </div>
      {/* ////row 2 */}
    </>
  );
};

export default PurchaseDetails;
